import { render, staticRenderFns } from "./BindDTQModal.vue?vue&type=template&id=4b37e07c&scoped=true"
import script from "./BindDTQModal.vue?vue&type=script&lang=js"
export * from "./BindDTQModal.vue?vue&type=script&lang=js"
import style0 from "./BindDTQModal.vue?vue&type=style&index=0&id=4b37e07c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b37e07c",
  null
  
)

export default component.exports